import React from 'react';

import Dialog from '../../../../../reusables/Dialog';
import DialogExtraCaption from '../../../../../reusables/Dialog/extras/caption';

interface IProps {
  handlerClose: () => void;
  show: boolean;
}

const ModalConfirm = ({ handlerClose, show }: IProps) => (
  <Dialog
    handlerClose={() => handlerClose()}
    maxWidth="360px"
    show={show}
    textButtonA="Entendido"
    zIndex={1000}
    handlerButtonA={() => handlerClose()}
  >
    <DialogExtraCaption
      subtitle="Recuerda asistir puntual en la fecha y hora que seleccionaste."
      title="¡Reserva completada!"
    />
  </Dialog>
);

export default ModalConfirm;
